(function ($) {

    $(document).ready(function () {
        if ((".banner-second-level").length > 0) {
            // setTimeout(function () {
            //     $(".banner-second-level").css("opacity", "1");
            // }, 500);

            $('.banner-second-level .btn-wrap .explore').on('click', function (e) {
                e.preventDefault();
                var href = $(this).attr('href');
                $('html, body').animate({
                    scrollTop: $(href).offset().top
                }, 500);
            });
        }
        $(".banner-second-level").each(function () {
            $(this).find('.btn-wrapper a[href*=\".xml\"]').addClass('rss-feed');
        });

        $('.banner-second-level .btn-wrapper a[href*=\".xml\"]').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            window.open(url, '_blank');
        });
    });

})(jQuery);